import axios from 'axios'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api', // API 基础URL
  timeout: 120000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在请求发送之前做一些处理
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = token
    }
    return config
  },
  error => {
    // 处理请求错误
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // 这里可以根据后端的数据结构进行调整
    if (res.code === 200) {
      return res.data
    } else {
      // 处理错误情况
      const error = new Error(res.message || 'Error')
      error.code = res.code
      return Promise.reject(error)
    }
  },
  error => {
    // 处理 HTTP 错误状态
    let message = '网络错误'
    if (error.response) {
      switch (error.response.status) {
        case 401:
          message = '未授权，请登录'
          // 可以在这里处理登录过期的情况
          break
        case 403:
          message = '拒绝访问'
          break
        case 404:
          message = '请求地址出错'
          break
        case 500:
          message = '服务器内部错误'
          break
        default:
          message = error.response.data.message || '未知错误'
      }
    }
    console.error('Response error:', message)
    return Promise.reject(error)
  }
)

// 封装请求方法
export const request = {
  get (url, params, config = {}) {
    return service.get(url, { params, ...config })
  },
  post (url, data, config = {}) {
    return service.post(url, data, config)
  },
  put (url, data, config = {}) {
    return service.put(url, data, config)
  },
  delete (url, params, config = {}) {
    return service.delete(url, { params, ...config })
  }
}

export default service
